interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, totalPages: number): number[] {
  const pages = new Set<number>();
  pages.add(1);
  pages.add(totalPages);
  for (let i = page - 1; i <= page + 1; i += 1) {
    if (i >= 1 && i <= totalPages) {
      pages.add(i);
    }
  }
  return Array.from(pages).sort((a, b) => a - b);
}

export default function Pagination({
  page,
  totalPages,
  onChange,
}: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = buildPages(page, totalPages);

  const go = (target: number) => {
    if (target >= 1 && target <= totalPages && target !== page) {
      onChange(target);
    }
  };

  return (
    <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => go(page - 1)}
        disabled={page === 1}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-3 text-sm text-foreground-600 transition-colors hover:border-accent-300 hover:text-accent-600 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((item, index) => {
        const prev = pages[index - 1];
        const showGap = prev !== undefined && item - prev > 1;
        return (
          <span key={item} className="flex items-center gap-2">
            {showGap && <span className="px-1 text-foreground-300">…</span>}
            <button
              type="button"
              onClick={() => go(item)}
              className={`flex h-9 w-9 items-center justify-center rounded-md text-sm transition-colors cursor-pointer ${
                item === page
                  ? "bg-primary-500 font-semibold text-background-50"
                  : "border border-background-200 bg-background-50 text-foreground-600 hover:border-accent-300 hover:text-accent-600"
              }`}
            >
              {item}
            </button>
          </span>
        );
      })}

      <button
        type="button"
        onClick={() => go(page + 1)}
        disabled={page === totalPages}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-3 text-sm text-foreground-600 transition-colors hover:border-accent-300 hover:text-accent-600 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}